import { findIndex, isEmpty } from 'lodash';
import UnitsDB from 'src/fb/units-db';
import { auth as useAuthStore } from 'src/store/auth';

export default {

  async loadClinicUnits(forceRefresh = false) {
    const auth = useAuthStore();

    if (!auth.connectedClinic.id) { // For admins and sysAdmin without clinic
      return;
    }

    const unitsDb = new UnitsDB(auth.connectedClinic.id);

    if (!isEmpty(this.units) && !forceRefresh) {
      return;
    }
    this.units = await unitsDb.readAll();
  }, // loadClinicUnits()

  async addNewUnit(unitData) {
    const auth = useAuthStore();

    const unitsDb = new UnitsDB(auth.connectedClinic.id);

    const newUnit = await unitsDb.create({
      createdBy: auth.userDetails.userId,
      ...unitData,
    });

    this.units.push(newUnit);

    return newUnit;
  }, // addNewUnit()

  async editUnit(unitData) {
    const auth = useAuthStore();

    const unitsDb = new UnitsDB(auth.connectedClinic.id);

    await unitsDb.update(unitData);

    const unitIdx = findIndex(this.units, { id: unitData.id });

    this.units.splice(unitIdx, 1, unitData);
  }, // editUnit()

  async removeUnit(unitId) {
    const auth = useAuthStore();

    const unitsDb = new UnitsDB(auth.connectedClinic.id);

    await unitsDb.delete(unitId);

    const unitIdx = findIndex(this.units, { id: unitId });

    this.units.splice(unitIdx, 1);
  }, // removeUnit()

};
